import React from 'react';
import { API_URL } from '../../constants/api';
import { decodeFullToken, decodeToken } from '../../utils/TokenUtils';

export default function MadarasaFlyer() {
  const qrData = 'https://kaafipay.so/portal/business-registration';
  const decoded = decodeFullToken();
  console.log('decoded:', decoded);
  return (
    <>
      <style>{`
        .kf-wrap {
          width: 105mm;
          height: 148mm;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #e9eef5;
          font-family: 'Poppins', Arial, sans-serif;
        }

        .kf-card {
          width: 100%;
          height: 100%;
          background: white;
          border-radius: 14px;
          overflow: hidden;
          position: relative;
          box-shadow: 0 20px 40px rgba(0,0,0,0.15);
          display: flex;
          flex-direction: column;
        }

        /* Decorative shapes */
        .kf-card::before {
          content: "";
          position: absolute;
          width: 160px;
          height: 160px;
          background: linear-gradient(135deg, #0a7cff, #00c6ff);
          top: -40px;
          right: -40px;
          border-radius: 50%;
          opacity: 0.15;
        }

        .kf-card::after {
          content: "";
          position: absolute;
          width: 120px;
          height: 120px;
          background: #0a7cff;
          bottom: -40px;
          left: -40px;
          border-radius: 50%;
          opacity: 0.1;
        }

        /* HEADER */
        .kf-header {
          padding: 18px 14px 10px;
          text-align: center;
        }

        .kf-logo {
          width: 55px;
          height: 55px;
          margin: 0 auto 8px;
          border-radius: 12px;
          overflow: hidden;
          background: #f2f6ff;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          color: #0a7cff;
        }

        .kf-logo img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .kf-title {
          font-size: 20px;
          font-weight: 700;
          color: #0a7cff;
        }

        .kf-sub {
          font-size: 11px;
          color: #666;
        }

        /* CONTENT */
        .kf-body {
          padding: 10px 14px;
          flex: 1;
        }

        .kf-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 8px;
        }

        .kf-item {
          background: #f8fbff;
          padding: 8px;
          border-radius: 8px;
          font-size: 10.5px;
          border: 1px solid #eef3ff;
        }

        .kf-item strong {
          display: block;
          font-size: 11px;
          color: #0a7cff;
          margin-bottom: 2px;
        }

        /* CTA */
        .kf-cta {
          margin: 10px 14px;
          background: linear-gradient(135deg, #0a7cff, #00c6ff);
          color: white;
          border-radius: 10px;
          padding: 10px;
          text-align: center;
        }

        .kf-cta h3 {
          margin: 0;
          font-size: 13px;
        }

        .kf-qr {
          margin: 8px auto 0;
          width: 70px;
          height: 70px;
          background: white;
          padding: 4px;
          border-radius: 6px;
        }

        /* FOOTER */
        .kf-footer {
          text-align: center;
          font-size: 9px;
          padding: 8px;
          color: #555;
          border-top: 1px solid #eee;
        }


        @media print {
  @page {
    size: 105mm 148mm; /* force exact A6 */
    margin: 0;
  }

  html, body {
    width: 105mm;
    height: 148mm;
    margin: 0 !important;
    padding: 0 !important;
  }

  .kf-wrap {
    position: fixed;
    top: 0;
    left: 0;
    width: 105mm;
    height: 148mm;
    margin: 0;
    padding: 0;
    background: white;
  }

  .kf-card {
    width: 100%;
    height: 100%;
    border-radius: 0;
    box-shadow: none;
  }
}
      `}</style>

      <div className="kf-wrap">
        <div className="kf-card">
          {/* HEADER */}
          <div className="kf-header">
            <div className="kf-logo">
              {/* Replace with your real logo */}
              <img src={`${API_URL}/${decoded?.logo}`} alt="logo" />
            </div>
            <div className="kf-title">Kaafipay System</div>
            <div className="kf-sub">Smart Madrasa Management Solution</div>
          </div>

          {/* BODY */}
          <div className="kf-body">
            <div className="kf-grid">
              <div className="kf-item">
                <strong>📚 Management</strong>
                Students, Parents, Teachers
              </div>

              <div className="kf-item">
                <strong>💰 Finance</strong>
                Fees, Receipts, Reports
              </div>

              <div className="kf-item">
                <strong>📊 Tracking</strong>
                Attendance & Lessons
              </div>

              <div className="kf-item">
                <strong>📲 WhatsApp</strong>
                Instant Parent Updates
              </div>

              <div className="kf-item">
                <strong>📝 Exams</strong>
                Marks & Reports
              </div>

              <div className="kf-item">
                <strong>🌍 Languages</strong>
                EN | AR | SO | SW
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="kf-cta">
            <h3>Scan to Register</h3>
            <img
              className="kf-qr"
              src={`https://api.qrserver.com/v1/create-qr-code/?size=120x120&data=${qrData}`}
              alt="QR Code"
            />
          </div>

          {/* FOOTER */}
          <div className="kf-footer">
            info@kaafipay.so • +254 769 622 455 • www.kaafipay.so
          </div>
        </div>
      </div>
    </>
  );
}
